const UseFormProgressUtils = module.exports = {};

UseFormProgressUtils.buildTrackedProgressFields = ({
    fields = [],
    extraFields = [],
    excludedFields = []
}) => {

    const excludedFieldSet = new Set(excludedFields);

    return fields
        .concat(extraFields)
        .filter((field) => !excludedFieldSet.has(field));
};

UseFormProgressUtils.collectTrackedProgressFields = ({
    definitions = {},
    fields = Object.keys(definitions),
    extraFields = []
} = {}) => {

    const trackedFields = [];

    fields.forEach((fieldName) => {

        const definition = definitions[fieldName];

        if (!definition || definition.trackProfileProgress === false) {
            return;
        }

        trackedFields.push(definition.progressFieldName || fieldName);
    });

    return Array.from(new Set(trackedFields.concat(extraFields)));
};

UseFormProgressUtils.getProgressFieldName = ({
    definitions = {},
    field
} = {}) => definitions[field]?.progressFieldName || field;

UseFormProgressUtils.normalizeProgressValue = (value) => {

    if (value === '') {
        return null;
    }

    return value;
};

UseFormProgressUtils.buildProgressPayload = ({
    payload = {},
    definitions = {},
    renameField,
    normalizeValue = UseFormProgressUtils.normalizeProgressValue
}) => {

    const resolveFieldName = typeof renameField === 'function'
        ? renameField
        : (field) => UseFormProgressUtils.getProgressFieldName({
            definitions,
            field
        });

    return Object.keys(payload).reduce((collector, field) => {

        collector[resolveFieldName(field)] = normalizeValue(payload[field], field);
        return collector;
    }, {});
};

UseFormProgressUtils.getProgressHandlerName = ({
    field,
    prefix = 'saveProgress'
}) => `${prefix}${field}`;

UseFormProgressUtils.buildDebouncedProgressHandlers = ({
    fields = [],
    saveProgress,
    debounce,
    debounceMs,
    prefix = 'saveProgress'
}) => {

    if (typeof saveProgress !== 'function') {
        return {};
    }

    return fields.reduce((collector, field) => {

        collector[UseFormProgressUtils.getProgressHandlerName({
            field,
            prefix
        })] = debounce(saveProgress, debounceMs);
        return collector;
    }, {});
};
